<script>
  import Card from "../Card.svelte";

  export let funding;
  export let isLatest;

  // Keys and icons to display
  const MAP = {
    amount: { icon: "far fa-coins", tooltip: "Amount" },
    investors: { icon: "far fa-building", tooltip: "Investors" },
    date: { icon: "far fa-calendar", tooltip: "Date" },
  };
</script>

<Card type="funding" item={funding} {MAP} tag={isLatest ? "Latest" : null} />
